import { Subscribe } from "@litonarefin/components/Subscribe";
import Image from "next/image";
import { Facebook, Wordpress, Linkedin, Twitter, Youtube } from "@litonarefin/components/Icons";
import Link from "next/link";
import { getSourceSite } from "@litonarefin/utils/getSourceSite";
import FooterMenu from "@litonarefin/components/Footer/FooterMenu";

const siteSource = getSourceSite();

function JewelthemeFooter({ subscribeData, footerOne, footerTwo, footerThree, socialShare }) {
  const year = new Date().getFullYear();

  return (
    <footer
      className={`jlt-relative jlt-bg-[linear-gradient(125.97deg,_#F8FAFF_-0.08%,_rgba(232,_228,_255,_0)_99.8%)] jlt-pb-12 sm:jlt-pb-16 md:jlt-pb-28 sm:jlt-pt-28 md:jlt-pt-[154px] jlt-bg-cover jlt-bg-center jlt-pt-24`}
    >
      {/* Decorative: `fill` stretches the bitmap to the footer box unless
          object-fit is set, which distorts it (the box and the asset have
          different aspect ratios). Empty alt keeps it out of the a11y tree. */}
      <Image
        src={"/footer-mash.webp"}
        alt=""
        aria-hidden="true"
        fill={true}
        sizes="100vw"
        className="jlt-z-[1] jlt-object-cover jlt-object-center"
      />
      <div className="jlt-container jlt-max-w-[1280px] jlt-mx-auto jlt-px-8 jlt-z-[1] jlt-relative">
        <div className="jlt-grid jlt-gap-y-8 md:jlt-grid-cols-2 lg:jlt-grid-cols-5">
          <FooterMenu label="Products" menus={footerOne} />
          <FooterMenu label="Supports" menus={footerTwo} />
          <FooterMenu label="Company" menus={footerThree} />

          <div className="jlt-flex jlt-flex-col lg:jlt-col-span-2 jlt-text-center md:jlt-text-left lg:jlt-text-left jlt-items-center md:jlt-items-start lg:jlt-items-start">
            <Link prefetch={false} href={"/"}>
              <Image
                src={"/logo.svg"}
                alt={"Footer Logo"}
                width={224}
                height={36}
                sizes={"100vw"}
                style={{
                  height: "36px",
                  width: "auto",
                }}
              />
            </Link>
            <p className="jlt-mt-9 jlt-text-lg jlt-font-medium jlt-color-[#16213E] jlt-mb-4">
              Subscribe to our newsletter and get instant product updates and special discounts
            </p>

            <Subscribe listID={subscribeData?.listID} tagID={subscribeData?.tagID} />

            <div className="jlt-flex jlt-text-center jlt-gap-x-2 jlt-mt-6">
              {socialShare?.facebook ? (
                <a
                  href={socialShare.facebook}
                  target="_blank"
                  className="jlt-flex jlt-items-center"
                  aria-label="Read more about Facebook Page"
                >
                  <Facebook />
                </a>
              ) : null}

              {socialShare?.twitter ? (
                <a href={socialShare.twitter} target="_blank" className="jlt-flex jlt-items-center" aria-label="Read more about Twitter">
                  <Twitter color="#000000" />
                </a>
              ) : null}

              {socialShare?.youtube ? (
                <a href={socialShare.youtube} target="_blank" className="jlt-flex jlt-items-center" aria-label="Watch the YouTube video for more details">
                  <Youtube />
                </a>
              ) : null}

              {socialShare?.wordpress ? (
                <a
                  href={socialShare.wordpress}
                  target="_blank"
                  className="jlt-flex jlt-items-center"
                  aria-label="Read more about WordPress"
                >
                  <Wordpress />
                </a>
              ) : null}

              {socialShare?.linkedin ? (
                <a
                  href={socialShare.linkedin}
                  target="_blank"
                  className="jlt-flex jlt-items-center"
                  aria-label="Read more about Linkedin"
                >
                  <Linkedin />
                </a>
              ) : null}
            </div>
          </div>
        </div>
        <div className="jlt-flex jlt-flex-col md:jlt-flex-row jlt-justify-between jlt-items-center jlt-mt-24">
          <div className="jlt-text-[#ADADBC] jlt-mb-4 md:jlt-mb-0 jlt-text-center md:jlt-text-left">
            <Link prefetch={false} className="jlt-font-bold jlt-text-[--primary]" href={"/"}>
              {siteSource === "wpadminify" ? "WP Adminify" : process.env.NEXT_PUBLIC_SOURCE_SITE}
            </Link>
            <div className="jlt-inline">
              {" "}
              &copy; 2014-{year} All rights reserved. Built with{" "}
              <div className="jlt-flex jlt-items-center jlt-gap-1">
                <svg
                  width="16"
                  height="14"
                  viewBox="0 0 16 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.6133 2.05298C13.2789 1.71736 12.8815 1.45107 12.4439 1.26937C12.0063 1.08767 11.5371 0.994141 11.0633 0.994141C10.5895 0.994141 10.1204 1.08767 9.68278 1.26937C9.2452 1.45107 8.84778 1.71736 8.51333 2.05298L8 2.57298L7.48666 2.05298C7.15221 1.71736 6.7548 1.45107 6.31721 1.26937C5.87962 1.08767 5.41047 0.994141 4.93666 0.994141C4.46285 0.994141 3.9937 1.08767 3.55612 1.26937C3.11853 1.45107 2.72112 1.71736 2.38666 2.05298C0.97333 3.46631 0.886663 5.85298 2.66666 7.66631L8 12.9996L13.3333 7.66631C15.1133 5.85298 15.0267 3.46631 13.6133 2.05298Z"
                    stroke="var(--primary)"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>{" "}
                by{" "}
                <a href="https://pixarlabs.com" target="_blank" className="jlt-text-[#16213E]">
                  Pixar Labs
                </a>
              </div>
            </div>
          </div>
          <Image src={"/payment.webp"} alt="Accepted payment methods - Visa, Mastercard, American Express, PayPal" width={194} height={24} sizes={"100vw"} />
        </div>
      </div>
      {/* <Fomo /> */}
    </footer>
  );
}

export default JewelthemeFooter;
